import { resolvePublicLogoUrl, normalizeAuthRedirectSetting, DEFAULT_HELIX_LOGIN_URL, DEFAULT_LOGOUT_URL } from '@onify/helix-core';

/**
 * Resolve Helix runtime config.
 *
 * - `loginUrl`: env `HELIX_LOGIN_URL` only (must match nginx / Vite proxy location) — never API settings.
 * - `logoutUrl`: API `logout_url` on `/public/settings` (path-only) → `DEFAULT_LOGOUT_URL` fallback.
 * - `error_url` / `internal_login_page`: API only — not app config (api redirects the user).
 * - Deploy topology (`HELIX_API_URL`, `HELIX_BASE_URL`, hub path env vars, Vite `BASE_URL`) stays env-based.
 * - API setting keys are snake_case; app / helix config properties stay camelCase.
 */
export function getHelixConfig(publicSettings = {}) {
  const apiBaseUrl = import.meta.env.HELIX_API_URL;

  const loginUrl = import.meta.env.HELIX_LOGIN_URL || DEFAULT_HELIX_LOGIN_URL;
  const logoutUrl = normalizeAuthRedirectSetting('logout_url', publicSettings.logout_url ?? publicSettings.logoutUrl) ?? DEFAULT_LOGOUT_URL;

  return {
    hubAppUrl: import.meta.env.ONIFY_HUB_APP_URL,
    logoutUrl,
    loginUrl,
    hubApiPath: import.meta.env.ONIFY_HUB_API_PATH,
    isProduction: import.meta.env.PROD,
    baseUrl: import.meta.env.BASE_URL,
    loginLogoUrl: resolvePublicLogoUrl(apiBaseUrl, publicSettings) ?? undefined,
  };
}

// Backwards-compatible default export using env + bundled defaults (no public settings yet).
export const helixConfig = getHelixConfig();
